import React, {Dispatch, FC, ReactElement, SetStateAction, useState} from 'react';
import {AccordionWrapper, AccordionTitle, AccordionContent} from './Accordion.styles';
import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import {ChevronDown, ChevronUp} from '@carbon/icons-react';

interface AccordionProps {
  content: React.ReactNode | ReactElement;
  setStateOutside?: Dispatch<SetStateAction<boolean>>;
  contentWidth?: string;
  marginLeft?: string;
}

const Accordion: FC<AccordionProps> = ({
  content,
  setStateOutside,
  contentWidth,
  marginLeft,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <AccordionWrapper contentWidth={contentWidth} marginLeft={marginLeft}>
      <AccordionContent isOpen={isOpen}>{content}</AccordionContent>
      <AccordionTitle
        onClick={() => {
          setIsOpen(!isOpen);
          if (setStateOutside) {
            setStateOutside(!isOpen);
          }
        }}>
        <Text text={isOpen ? 'Свернуть' : 'Развернуть'} color={theme.colors.accent00} />
        {!isOpen && <ChevronDown size={16} />}
        {isOpen && <ChevronUp size={16} />}
      </AccordionTitle>
    </AccordionWrapper>
  );
};

export default Accordion;
